import { render, staticRenderFns } from "./PaginationNavNumberGen.vue?vue&type=template&id=cf567ff4&"
import script from "./PaginationNavNumberGen.vue?vue&type=script&lang=js&"
export * from "./PaginationNavNumberGen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports